import { render } from "./DangerFlags.vue?vue&type=template&id=26d235b7&scoped=true"
import script from "./DangerFlags.vue?vue&type=script&lang=js"
export * from "./DangerFlags.vue?vue&type=script&lang=js"

import "./DangerFlags.vue?vue&type=style&index=0&id=26d235b7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26d235b7"]])

export default __exports__